import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Order } from '../../models/order/order.model';
import { CreatePurchaseOrder } from '../../models/PurchaseOrder/create-purchase-order.model';
import { OrderDetail } from '../../models/order/order-detail.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BulkChangeOrderStatus } from '../../models/order/order.model';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class OrderService {
  private service = "api/Order"; //Controller Name
  private serviceUtility = "api/Utility"; //Controller Name
  private finance ="api/Finance";
  public OrderList: Order[];
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  GetOrders() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }





  GetOrdersGrid(pageNumber: number, pageSize: number, orderStatusId: string, searchKeyword: string, customerName:string,customerPhone:string) {
    return this.http.get(`${this.service}/GetOrdersGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&orderStatusId=` + orderStatusId + `&searchKeyword=` + searchKeyword + `&customerName=` + customerName + `&customerPhone=` + customerPhone ,{
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetPurchasedOrdersGrid(pageNumber: number, pageSize: number,searchKeyword: string,vendorId:string) {
    return this.http.get(`${this.service}/GetPurchasedOrdersGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&searchKeyword=` + searchKeyword + `&vendorId=` + vendorId , {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  TrackingDetail(Tracking: string) {
    return this.http.get(`${this.service}/TrackingDetail?tracking=` + Tracking , {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  
  
  UpateCities() {
    return this.http.get(`${this.service}/UpateCities`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetApprovedOrderDetail() {
    return this.http.get(`${this.service}/GetPurchasedOrders`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  PlacePurchaseOrder(order: CreatePurchaseOrder) {
    //Todo
    //this.http.put(`${this.service}/CreatePurchaseOrder`, order, {})
    //  .subscribe(result => {
    //    this.router.navigate(["/purchase-order-list"]);
    //  });
    return this.http.put(`${this.service}/CreatePurchaseOrder`, order, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    });
    
  }  
 
  BulkChangeStatus(orderStatus: BulkChangeOrderStatus) {
    //Todo
    return this.http.put(`${this.service}/BulkOrderStausChange`, orderStatus, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetwithDrawlStatuses() {
    //Todo
    return this.http.get(`${this.serviceUtility}/GetwithDrawlStatuses`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 
  Createlabel(orderStatus: BulkChangeOrderStatus) {
    //Todo
    return this.http.put(`${this.service}/CreateOrderShipments`, orderStatus, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 
  ChangeOrderDetailStatus(orderdetailID: number, statusID: string) {
    return this.http.get(`${this.service}/ChangeOrderDetailStatus?orderDetailStatus=` + statusID + `&orderdetailID=` + orderdetailID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 
  ChangeOrderStatus(orderID: string, orderStatusId: number) {
    return this.http.get(`${this.service}/ChangeOrderStatus?orderId=` + orderID + `&orderStatusId=` + orderStatusId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 

  CancelOrderDetail(orderdetailID: number) {
    return this.http.get(`${this.service}/CancelOrderDetail?orderdetailID?=` + orderdetailID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AppendOrder(orderdetail: OrderDetail, orderid: string) {
    
    return this.http
      .post(`${this.service}/AppendOrderDetail`, orderdetail, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      });
  }

  GetOrderDetailByID(id: number) {
    return this.http.get(`${this.service}/GetOrderDetailByID?orderdetailID=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  UpdateWithDrawls(id: number,status:string) {
    return this.http.get(`${this.finance}/UpdateWithDrawalRequestStatus?id=` + id + `&status=` + status, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  VerifyOrderToPO(id: string) {
    return this.http.get(`${this.service}/VerifyOrder?orderdetailID=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetOrderDetailByOrder(id: string) {
    return this.http.get(`${this.service}/ViewOrderDetail?Id=` + id + `&isCustomer=` + false, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    }) 
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  PrintOrder(orderStatus: BulkChangeOrderStatus) {
    //Todo
    return this.http.put(`${this.service}/PrintOrder`, orderStatus, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetOrderStatuses() {
    return this.http.get(`${this.serviceUtility}/GetOrderStatuses`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetPurchaseOrderStatuses() {
    return this.http.get(`${this.serviceUtility}/GetPurchaseOrderStatuses`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetOrderDetailStatuses() {
    return this.http.get(`${this.serviceUtility}/GetOrderDetailStatuses`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetCustomerOrderAdress(Id: number) {
    return this.http.get(`${this.service}/GetCustomerOrderAdress?orderId=` + Id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //UpdateCustomerOrderAdress(model: Order) {
  
  //  return this.http.post(`${this.service}/UpdateCustomerOrderAdress`, model, {})
  //    .map((response: Response) => response.json())
  //    .catch(this.errorHandler);
  //}
  UpdateCustomerOrderAdress(model: Order) {
    return this.http.post(`${this.service}/UpdateCustomerOrderAdress`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/order/order.service.ts